import React from 'react';
import { AlertTriangle, Download, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { adminApi } from '../../../lib/adminAuth';
import { downloadPdf, errMsg } from './docUtils';

export default function DocPreviewDialog({ open, onClose, previewUrl, pdfUrl, pdfName, title }) {
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState('');
  React.useEffect(() => {
    if (!open || !previewUrl) return;
    setData(null); setError('');
    adminApi.get(previewUrl).then((r) => setData(r.data)).catch((e) => setError(errMsg(e, 'Could not load the preview')));
  }, [open, previewUrl]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl h-[90vh] flex flex-col" data-testid="doc-preview-dialog">
        <DialogHeader className="flex-row items-center justify-between gap-3 space-y-0 pr-8">
          <DialogTitle>{title || 'Preview'}</DialogTitle>
          {pdfUrl && (
            <Button size="sm" variant="outline" onClick={() => downloadPdf(pdfUrl, pdfName)} data-testid="doc-preview-download">
              <Download className="w-4 h-4 mr-1.5" /> Download PDF
            </Button>
          )}
        </DialogHeader>
        {data?.warnings?.length > 0 && (
          <div className="flex gap-2 p-2.5 rounded-lg bg-amber-50 text-amber-800 text-xs" data-testid="doc-preview-warnings">
            <AlertTriangle className="w-4 h-4 shrink-0" />
            Some clauses refer to clauses that are not included: {data.warnings.join(', ')}. Tick them or edit the reference before sending.
          </div>
        )}
        {error && <p className="text-sm text-rose-600">{error}</p>}
        {!data && !error && <div className="flex-1 flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-fuchsia-600" /></div>}
        {data && (
          <iframe title="Document preview" srcDoc={data.html} className="flex-1 w-full rounded-lg border border-slate-200 bg-white"
            style={{ padding: 0 }} data-testid="doc-preview-frame" />
        )}
      </DialogContent>
    </Dialog>
  );
}
